import PackAssignDropdown from "./PackAssignDropdown";
import {
  MATRIX_POOL_FILTER_OPTIONS,
  readMatrixPoolFilter,
  writeMatrixPoolFilter,
} from "../utils/gameWordPool";

export default function MatrixPoolFilterDropdown({ value, onChange }) {
  const handleChange = (nextValue) => {
    writeMatrixPoolFilter(nextValue);
    onChange(nextValue);
  };

  return (
    <div className="game-stats-matrix-pool-filter">
      <PackAssignDropdown
        options={MATRIX_POOL_FILTER_OPTIONS}
        value={value || readMatrixPoolFilter()}
        onChange={handleChange}
        ariaLabel="Filtrer la matrice par pool de niveau"
      />
    </div>
  );
}
